module.exports = __webpack_public_path__ + "img/selected6-min.c736c154.png";